"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castel-gabbiano": {
    "539e61ec": [{
      "hkey": "255ac5c0",
      "slug": "bettola",
      "name": "Bettola",
      "primary": true,
      "skipSearch": false
    }],
    "cascine-bettola": [{
      "hkey": "255ac5c0",
      "slug": "bettola",
      "name": "Bettola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4a71383b": [{
      "hkey": "a0ecdbb7",
      "slug": "castel-gabbiano",
      "name": "Castel Gabbiano",
      "primary": true,
      "skipSearch": false
    }],
    "frana": [{
      "hkey": "a0ecdbb7",
      "slug": "castel-gabbiano",
      "name": "Castel Gabbiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;